import React, { useState } from 'react';
import { Button, Drawer } from 'antd';
import { MenuOutlined, MedicineBoxOutlined, EyeOutlined, LogoutOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import '../styles/admin.css';

// Theme Ant Design riêng cho /admin (kế thừa styles/theme.js): chữ Be Vietnam Pro, màu trạng thái theo admin.css.
// Bọc cả modal vì modal render qua portal, nằm ngoài .adm
export const adminTheme = {
  token: {
    fontFamily: `'Be Vietnam Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`,
    colorPrimary: '#005537',
    colorSuccess: '#005537',
    colorWarning: '#c8862b',
    colorError: '#b42318',
    colorTextBase: '#0f1f19',
    colorTextSecondary: '#4b5d55',
    colorBorderSecondary: '#dfe6e1',
    borderRadius: 8,
  },
  components: {
    Button: { borderRadius: 8 },
  },
};

// Thanh bên: các mục gom theo nhóm, số màu hổ phách là việc đang chờ xử lý
function AdminSidebar({ sections, activeKey, onSelect, user, roleLabel, onViewSite, onLogout }) {
  const groups = [];
  sections.forEach((s) => {
    const g = groups.find((x) => x.name === s.group);
    if (g) g.items.push(s);
    else groups.push({ name: s.group, items: [s] });
  });

  return (
    <aside className="adm-side">
      <Link to="/" className="adm-brand">
        <span className="adm-brand-mark">
          <MedicineBoxOutlined />
        </span>
        <span className="adm-brand-name">
          Đào Tạo Nhà Thuốc
          <span className="adm-brand-sub">Trang quản trị</span>
        </span>
      </Link>

      <nav className="adm-nav" aria-label="Mục quản trị">
        {groups.map((g) => (
          <React.Fragment key={g.name}>
            <div className="adm-nav-group">{g.name}</div>
            {g.items.map((s) => (
              <button
                key={s.key}
                type="button"
                className={`adm-nav-item${s.key === activeKey ? ' is-active' : ''}`}
                aria-current={s.key === activeKey ? 'page' : undefined}
                onClick={() => onSelect(s.key)}
              >
                {s.icon}
                <span className="adm-nav-label">{s.title}</span>
                {s.pending > 0 && (
                  <span className="adm-count" title={s.pendingHint}>
                    {s.pending}
                  </span>
                )}
              </button>
            ))}
          </React.Fragment>
        ))}
      </nav>

      <div className="adm-side-foot">
        <div className="adm-me">
          <span className="adm-me-avatar">{(user?.fullName || user?.email || '?').trim().charAt(0).toUpperCase()}</span>
          <div style={{ minWidth: 0 }}>
            <div className="adm-me-name">{user?.fullName || user?.email}</div>
            <div className="adm-me-role">{roleLabel}</div>
          </div>
        </div>
        <button type="button" className="adm-nav-item" onClick={onViewSite}>
          <EyeOutlined />
          <span className="adm-nav-label">Xem giao diện học viên</span>
        </button>
        <button type="button" className="adm-nav-item" onClick={onLogout}>
          <LogoutOutlined />
          <span className="adm-nav-label">Đăng xuất</span>
        </button>
      </div>
    </aside>
  );
}

export function AdminShell({ sections, activeKey, onSelect, actions, children, ...sidebarProps }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const active = sections.find((s) => s.key === activeKey) || sections[0];

  const handleSelect = (key) => {
    onSelect(key);
    setDrawerOpen(false);
    window.scrollTo({ top: 0 });
  };

  const sidebar = (
    <AdminSidebar sections={sections} activeKey={activeKey} onSelect={handleSelect} {...sidebarProps} />
  );

  return (
    <div className="adm">
      {sidebar}

      <Drawer
        rootClassName="adm-drawer"
        placement="left"
        size={272}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        closable={false}
      >
        {sidebar}
      </Drawer>

      <div className="adm-main">
        <header className="adm-top">
          <Button
            className="adm-menu-btn"
            icon={<MenuOutlined />}
            aria-label="Mở menu quản trị"
            onClick={() => setDrawerOpen(true)}
          />
          <div className="adm-top-title">
            <div className="adm-crumb">{active?.group}</div>
            <h1>{active?.title}</h1>
          </div>
          {actions && <div className="adm-top-actions">{actions}</div>}
        </header>
        <div className="adm-body">{children}</div>
      </div>
    </div>
  );
}
